export const MemberTrainCourseCn = {
    xunjiadang:'已购买课程',
    peixunfuwu:'培训服务',
    jiage:'价格',
    zhuantai:'状态',
    caozuo:'操作',
    pingjiazhuantai:'课时'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/MemberTrainCourse/MemberTrainCourseCn.js